export const homeObjEight = {
    id: 'events_familyFunNight',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Events - Family',
    headline: 'Family Fun Night',
    description: 'The Alton Knights recently sponsored a \"Family Fun Night\" on the parking lot of St. Mary\'s School. There were multiple bounce houses, free kettle corn and snow cones, face painting and food and beverages.',
    
    buttonLabel: 'Get started',
    buttonPath: 'http://www.yahoo.com',
    imgStart: false,
    img: 'famFunNight.png',
    alt: 'image goes here..',
    dark: false,
    primary: false,
    darkText: true,
    lightTop: true
};

export const homeObjNine = {
    id: 'events_golf',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Events - Annual Golf Tournament',
    headline: 'Alton Knights of Columbus Annual Golf Tournament',
    description: 'The Alton Knights of Columbus annual golf tournament was very successful with 56 golfers participating. We would like to thank the golfers that participated and give special thanks to the sponsors for the event.',
    
    buttonLabel: 'Get started',
    buttonPath: 'http://google.com',
    imgStart: true,
    img: 'golf2022.png',
    alt: 'image goes here..',
    dark: true,
    primary: true,
    darkText: false,
    lightTop: false
};

export const homeObjEleven = {
    id: 'meetings',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Monthly Meetings',
    headline: 'Alton Council 460 Meeting Times',
    description: 'Council meetings, for members only, are held the second Thursday of each month at 7:30pm. All meetings are held at the Saints Peter and Paul Grade School on State Street in Alton. Rosary preceding meeting at 7:05pm. Members should try to be present for at least 4 meetings per year.',
    buttonLabel: 'Get started',
    buttonPath: 'http://google.com',
    imgStart: true,
    img: 'date_picker.svg',
    alt: 'image goes here..',
    dark: true,
    primary: true,
    darkText: false,
    lightTop: false
};

export const homeObjTwentyOne = {
    id: 'bowlingHistory',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'KofC Bowling History',
    headline: 'Alton Knights of Columbus Bowling League History',
    
    description: 'The Alton Knights of Columbus bowling league was established in 1923 and originally bowled at the St Mary\’s Church. In 1925 there were fifteen 5-man teams in the league. In 1929 there were 12 teams in the Alton Knights of Columbus league and the Pilots won the league that year with 60 wins and 39 loses. The Pilots 5 man team average was 754 and their high game and series were 906 and 2507 that year. High average in 1929 was J. H. Waiters with a 180 average. Many familiar family names bowled that year including Al and Nick Schwegel, Joe Kelly, Leo, Louis and Thomas Jun, H Berger, several Crivello\’s and Springman\’s, Herb Hellrung, D Maher, and Emmert Wyss with the leagues low average of 118. Team names in 1929 were Pathfinders, Explorers, Commodores, Captains, Breakers, Columbias, Pirates, Discoverers, Navigators, Mariners, Admirals, and Pilots. The annual banquet in 1929 was held at the Mineral Springs Hotel. In 1930 the Mariners won the league with 62 wins and 37 defeats and a team average of 798. There were still 12 teams in the league. High average went to James Mahoney with a 184 average. Future Alton mayor Leo J. Struif bowled in the league and had a 174 average this year. Also bowling in 1930 were J Barrett with an average of 160 and A J Manns with an average of 164. In 1937 the Explorers under team captain Joe Stephan, future coach of the Marquette High School football team, won the league with other team members of Huber, Schwegel, Joehl and they were missing a fifth bowler so the team used a blind score of 121. The losing team was the Navigators with team members Wickenhauser, Long, Klinke, Springman, and Jun. The banquet in 1937 was held at the SS. Peter and Paul\’s hall. In 1938 the Pirates under team captain Joe Curlovic won the league with other team members being J Hornsey, V Williams, J Davey, and L Geltz. The Navigators came in second under captain Ed Brown with other team member being E Hegeman, F Huber, J Mahoney, and F Joehl. The bowling was at Acme lanes on Broadway this year with the annual banquet held at the St. Patrick\’s hall. In the fall of 1938 the league started out with 10 teams kicking off its sixteenth consecutive year and continued to bowl at Acme lanes on Broadway. In 1939 the banquet was held at Marquette High School and Douglas Knowles was elected president of the league. Some familiar names bowling in 1939 included Heine Berger, Herb Wickenhauser, George Hornsey, Vic Wardein, Ed Norton, Fred and Ralph Joehl, and Howard Tueth. In 1940 the banquet was again held at Marquette High School and in 1942 and 1945 at St Patrick\’s School hall. The league originated at St Mary\’s lanes in 1923, later moved to Turner Hall and then to Wood River before moving to Acme Lanes in Alton in 1928. The league followed Acme Lanes to Godfrey Road until it switched over to Riverboat Lanes and moved moved to Bowl Haven when Riverboat closed.',
    
    buttonLabel: 'Get started',
    buttonPath: 'http://google.com',
    imgStart: true,
    img: 'date_picker.svg',
    alt: 'image goes here..',
    dark: true,
    primary: true,
    darkText: false,
    lightTop: false
};

export const coats4kids2022 = {
    id: 'events_coats4kids',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Coats for Kids',
    headline: 'Council 460 - Donates to Coats for Kids',
    
    description: 'Each year the Alton Knights of Columbus donate several cases of new coats. Council 460 Grand Knight - Richard Ruedin, District Deputy - Mark Droste and Financial Secretary - Joel Buesteton deliver 15 cases of coats to Catholic Charities.',
    buttonLabel: 'Get started',
    buttonPath: 'http://google.com',
    imgStart: true,
    img: 'coats4kids.png',
    alt: 'image goes here..',
    dark: true,
    primary: true,
    darkText: false,
    lightTop: false
};